/**
 * @file
 * @version @@APP_VERSION@@
 * @description @@APP_DESCRIPTION@@
 * @date @@APP_BUILD_DATE@@
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app.jsx";
import "./assets/fonts/font-awesome.min.css";
import "./assets/fonts/noto-sans.css";
import store from "./app/store.js";
import { Provider } from "react-redux";

var host = document.createElement("div");
host.id = "app";
document.body.appendChild(host);


ReactDOM.createRoot(host).render(
    <React.StrictMode>
        <Provider store={ store }>
            <App/>
        </Provider>
    </React.StrictMode>
);
